module.exports = __webpack_public_path__ + "img/search.5be2180d.svg";